import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazyNotificationSettings = lazyWithRetry(() => import('./notificationSettings'));
